/* eslint no-unused-vars: 0 */

import type { Canvas } from 'fabric';
import { FabricCanvasTool } from '../index';
import { SketchProperties, Tool } from '../../../../types';

// eslint-disable-next-line import/prefer-default-export
export class Select extends FabricCanvasTool {
    type(): Tool {
        return Tool.SELECT;
    }

    constructor(canvas: Canvas) {
        super(canvas);
    }

    configureCanvas(props: SketchProperties) {
        this.canvas.isDrawingMode = false;
        this.canvas.selection = true;
        this.canvas.forEachObject(o => {
            o.selectable = true;
            o.evented = true;
        });
    }
}
